<section class="footer-section">

  <div class="footer-centered-container">

    <div class="footer-top">
      <div class="footer-copyright">
        ©2026 Teradata. All Rights Reserved
      </div>
      
      <div class="footer-main-links">
        <a (click)="copyToken()" target="_blank">
          <fa-icon [icon]="faCopy" (click)="copyToken()" matTooltip="Copy token" #tokenTooltip="matTooltip"></fa-icon>
          Rest API Token
        </a>
        <a [href]="getAPIDocsLink()" target="_blank">
          <fa-icon [icon]="faExternalLink"></fa-icon>
          Rest API Docs
        </a>
        <a (click)="requestSupport()">Support</a>
        <a href="https://www.teradata.com/Privacy">Privacy</a>
        <a href="https://www.teradata.com/Privacy#do-not-sell-share">Don't sell/share my info</a>
        <a href="https://www.teradata.com/Legal/Terms-of-Use">Terms of use</a>
        <a href="https://www.teradata.com/Legal/Legal-Notice">Legal</a>
        <a href="https://www.teradata.com/Product-Support-Policy">Support policies</a>
        <a (click)="showConsentForm()">Cookie Preferences</a>
      </div>
    </div>

  </div>

</section>
